export const init = () => {
  // enable smooth scroll on features anchors
  const $htmlBody = $('html, body');
  $(document).on('click', '.p-venuepage-header__features a[href^="#"]', function smoothScroll(event) {
    event.preventDefault();

    $htmlBody.animate({
      scrollTop: $($.attr(this, 'href')).offset().top,
    }, 500);

    document.activeElement.blur();
  });
};
